import { render, staticRenderFns } from "./ContactImportActionCard.vue?vue&type=template&id=374a389a&"
import script from "./ContactImportActionCard.vue?vue&type=script&lang=js&"
export * from "./ContactImportActionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports